// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__hsbcs","text":"Footer_text__Ie4sD","lang":"Footer_lang__PSLL9","icons":"Footer_icons__lW1kf"};